import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { Demo } from '../components/Demo';
import { Analytics } from '../components/Analytics';
import { Flavors } from '../components/Flavors';
import { Pricing } from '../components/Pricing';
import { Footer } from '../components/Footer';
import { EnvironmentBanner } from '../components/EnvironmentBanner';
import backgroundImage from '@/assets/xrepl-landing.png';

export function LandingPage() {
  return (
    <div 
      className="min-h-screen bg-white dark:bg-[#0A1628]"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}
    >
      <EnvironmentBanner />
      <Header />
      <main>
        <div data-saxa-bg="dark"><Hero /></div>
        <div data-saxa-bg="light"><Features /></div>
        <div data-saxa-bg="light"><Demo /></div>
        <div data-saxa-bg="dark"><Analytics /></div>
        <div data-saxa-bg="light"><Flavors /></div>
        <div data-saxa-bg="light"><Pricing /></div>
      </main>
      <div data-saxa-bg="light"><Footer /></div>
    </div>
  );
}